import React from "react";
import LeagMainHead from "../../common/LeagMainHead";
import PlayersDetail from "../../golf/PlayersDetail";


const GolfPlayerWidgetWrap = (props) => {
  const {
    dataId,
    dataType,
    head,
    data,
    baseUrl,
    sport,
    loadCSS,
    dataClient,
    websiteBaseUrl,
    dataPath,
    dataTitle,

  } = props;

  const renderHeadWrap = (currentTab, children) =>
    head ? (
      <LeagMainHead
        id={dataId}
        headData={data}
        baseUrl={baseUrl}
        sport={sport}
        state="player"
        dataClient={dataClient}
        currentTab={currentTab}
        websiteBaseUrl={websiteBaseUrl}
        dataPath={dataPath}
        widgetTitle={dataTitle}
      >
        {children}
      </LeagMainHead>
    ) : (
      children
    );

  switch (dataType) {
    case "golf-player-card":
      return renderHeadWrap("player card",
        <PlayersDetail
          data={data?.data}
          dataClient={dataClient}
          loadCSS={loadCSS}
        />
      );


    default:
      return <h1>golf Player Widget Not Found!</h1>;
  }
};

export default GolfPlayerWidgetWrap;
